
import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import { OperationsManagementService } from "@/api/service-proxies";
import moment from "moment";
import { UserModule } from "@/store/modules/user";
import waterMark from "@/lib/waterMark";

@Component({
    name: "SchoolAnalysisMainTable"
})
export default class ScreenTv extends Vue {
    /*********************************************************************
     * 基础配置
     ********************************************************************/
    OperationPointsService = new OperationsManagementService();
    value1 = moment().format('YYYY-MM-DD');

    tableList: any[] = [];
    isTableLoading = false;
    tableHeight = 300;

    currentTime = this.getCurrentTime();
    nowDay = moment().add(8, 'hours').format("YYYY年MM月DD日");

    isFullScreen = false;
    isShowSearch = true;

    private timeTimer: NodeJS.Timeout | null = null;
    private autoRefreshTimer: NodeJS.Timeout | null = null;
    private tableScrollTimer: NodeJS.Timeout | null = null;

    @Ref('contentArea') contentArea!: HTMLElement;
    @Ref('fullscreenContainer') fullscreenContainer!: HTMLElement;
    private tableScrollContainer: HTMLElement | null = null;
    tableRowHeight = 48;
    private isScrollEnabled = true;
    oneLaoding=0
    mounted() {
        const navbar = document.querySelector('.navbar')
        if (navbar) {
            navbar.style.display = 'none'
        }
        this.initTimeUpdate();
        this.initAutoRefresh();
        this.listenFullScreenChange();
        this.getTableData();

        this.$nextTick(() => {
            this.calculateTableHeight();
            this.initTableScroll();
        });

        window.addEventListener('resize', this.handleWindowResize);
        this.removeWatermark();
    }

    beforeDestroy() {
        const navbar = document.querySelector('.navbar')
        if (navbar) {
            navbar.style.display = ''
        }
        this.clearAllTimers();
        if (this.isFullScreen) this.exitFullScreen();
        window.removeEventListener('resize', this.handleWindowResize);

        if (this.User && !UserModule.user.isEdcationUser) {
            waterMark.set("为垦小绿伞_" + this.User.name);
        }
    }

    get User() {
        return UserModule.user;
    }

    /*********************************************************************
     * 监听事件
     ********************************************************************/
    @Watch('tableList')
    onTableListChange() {
        setTimeout(() => {
            this.calculateTableHeight();
            this.initTableScroll();
        }, 500);
    }

    @Watch('isFullScreen')
    onFullScreenChange() {
        setTimeout(() => {
            this.calculateTableHeight();
            this.initTableScroll();
        }, 500);
    }

    @Watch('isShowSearch')
    onIsShowSearchChange() {
        this.$nextTick(() => {
            this.calculateTableHeight();
            this.initTableScroll();
        });
    }

    handleWindowResize = () => {
        this.calculateTableHeight();
        this.initTableScroll();
    }

    /*********************************************************************
     * 方法
     ********************************************************************/
    tableRowClassName({ row }: { row: any }): string {
        if (row.actualArriveNum > 0 && (row.wxPhoneOffLineCount > 0 || row.deviceOffLineCount > 0)) {
            return 'success-row'
        }
        return ''
    }

    hiddenSearch() {
        this.isShowSearch = !this.isShowSearch
        if (!this.isFullScreen) {
            this.enterFullScreen();
        } else {
            this.exitFullScreen();
        }
    }

    /*********************************************************************
     * 时间方法
     ********************************************************************/
    private getCurrentTime(): string {
        return moment().format("HH:mm:ss");
    }

    private initTimeUpdate() {
        this.currentTime = this.getCurrentTime();
        this.timeTimer = setInterval(() => {
            this.currentTime = this.getCurrentTime();
        }, 1000);
    }

    /*********************************************************************
     * 全屏方法
     ********************************************************************/
    private enterFullScreen() {
        if (this.fullscreenContainer.requestFullscreen) {
            this.fullscreenContainer.requestFullscreen().then(() => {
                this.isFullScreen = true;
            }).catch(err => {
                console.error('全屏失败:', err);
            });
        }
    }

    private exitFullScreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen().then(() => {
                this.isFullScreen = false;
            });
        }
    }

    private listenFullScreenChange() {
        const handleChange = () => {
            const isFull = !!(document.fullscreenElement);
            this.isFullScreen = isFull && document.fullscreenElement === this.fullscreenContainer;
        };
        document.addEventListener("fullscreenchange", handleChange);
    }

    /*********************************************************************
     * 数据请求
     ********************************************************************/
    getTableData(): Promise<void> {
        if(this.oneLaoding==0)this.isTableLoading = true;
        return this.OperationPointsService.getStudentDailyAttendanceStaticEveryDay(
            this.value1, "", "", "",null,""
        ).then((result: any) => {
            this.tableList = result.filter((x: any) => x.responsibleName != undefined && x.responsibleName != '') || [];
            this.oneLaoding=1
        }).catch((error: any) => {
            this.$message.error('请求失败，请重试');
            this.tableList = [];
        }).finally(() => {
            this.isTableLoading = false;
            setTimeout(() => {
                this.calculateTableHeight();
                this.initTableScroll();
            }, 300);
        });
    }

    /*********************************************************************
     * 自动刷新
     ********************************************************************/
     private initAutoRefresh() {
        this.autoRefreshTimer = setInterval(() => {
            this.value1 = moment().format('YYYY-MM-DD');
            this.getTableData();
        }, 600000);
    }

    /*********************************************************************
     * 表格高度计算
     ********************************************************************/
    private calculateTableHeight() {
        // 完全固定高度模式，不依赖动态计算
        const rowsToShow = this.isFullScreen ? 9 : 7;

        // 精确计算：行高 × 行数 + 表头高度 + 边框等
        const headerHeight = 36; // 表头固定高度
        const borderHeight = 2; // 边框高度
        const exactHeight = (rowsToShow * this.tableRowHeight) + headerHeight + borderHeight+24;

        this.tableHeight = exactHeight;
    }

    /*********************************************************************
     * 表格滚动逻辑 - 动态分页版本
     ********************************************************************/
    private initTableScroll() {
        if (this.tableScrollTimer) {
            clearInterval(this.tableScrollTimer);
            this.tableScrollTimer = null;
        }

        const found = this.findScrollContainer();
        if (found && this.tableList.length > 0) {
            this.startPageScroll();
        }
    }

    private findScrollContainer(): boolean {
        let container: HTMLElement | null = null;

        if (this.contentArea) {
            container = this.contentArea.querySelector('.el-table .el-table__body-wrapper') as HTMLElement;
        }
        if (!container) {
            container = document.querySelector('.el-table .el-table__body-wrapper') as HTMLElement;
        }

        if (container) {
            this.tableScrollContainer = container;
            return true;
        }
        return false;
    }

    private startPageScroll() {
        if (!this.tableScrollContainer) return;

        let currentPage = 0;
        const container = this.tableScrollContainer;

        this.$nextTick(() => {
            // 根据全屏状态设置每页行数
            const rowsPerPage = this.isFullScreen ? 9 : 7;
            const totalPages = Math.ceil(this.tableList.length / rowsPerPage);
            if (totalPages <= 1) {
                return;
            }

            // 初始滚动到顶部
            container.scrollTop = 0;

            this.tableScrollTimer = setInterval(() => {
                if (!this.isScrollEnabled) return;
                this.isScrollEnabled = false;

                // 计算下一页
                currentPage = (currentPage + 1) % totalPages;

                // 计算目标滚动位置
                const targetScrollTop = currentPage * rowsPerPage * this.tableRowHeight;
                const maxScrollTop = container.scrollHeight - container.clientHeight;
                const finalScrollTop = Math.min(targetScrollTop, maxScrollTop);
                // 平滑滚动
                this.smoothScroll(container, finalScrollTop, 800, () => {
                    this.isScrollEnabled = true;
                });

            }, 10000); // 10秒滚动一次
        });
    }

    private smoothScroll(
        container: HTMLElement,
        targetTop: number,
        duration: number,
        callback?: () => void
    ) {
        const start = container.scrollTop;
        const change = targetTop - start;
        const startTime = performance.now();

        const animateScroll = (timestamp: number) => {
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);

            const easeProgress = progress < 0.5
                ? 4 * progress * progress * progress
                : 1 - Math.pow(-2 * progress + 2, 3) / 2;

            container.scrollTop = start + change * easeProgress;

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            } else {
                this.isScrollEnabled = true;
                if (callback) callback();
            }
        };

        requestAnimationFrame(animateScroll);
    }

    /*********************************************************************
     * 工具方法
     ********************************************************************/
    private clearAllTimers() {
        if (this.timeTimer) clearInterval(this.timeTimer);
        if (this.autoRefreshTimer) clearInterval(this.autoRefreshTimer);
        if (this.tableScrollTimer) clearInterval(this.tableScrollTimer);
    }

    private removeWatermark() {
        if ((window as any).waterMark && typeof (window as any).waterMark.remove === 'function') {
            (window as any).waterMark.remove();
        } else {
            const watermarkElements = document.querySelectorAll('.watermark, #watermark-container');
            watermarkElements.forEach(el => el.remove());
        }
    }

    goBack() {
        this.$router.back();
    }
}
